// extracted by mini-css-extract-plugin
export default {"root":"Tooltip_root__Z5HIh"};